import { Collection, Model } from 'web-mojo';

class FirmwareBuild extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/firmware/build'
        });
    }

    variantKey() {
        return [this.get('board'), this.get('product'), this.get('customer'), this.get('channel')]
            .map(v => v || '—')
            .join(' / ');
    }

    isPending() {
        return this.get('state') === 'pending';
    }

    isPublished() {
        return this.get('state') === 'published';
    }

    isYanked() {
        return this.get('state') === 'yanked';
    }
}

class FirmwareBuildList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: FirmwareBuild,
            endpoint: '/api/firmware/build',
            ...options
        });
    }
}

class FirmwareBuildHistory extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/firmware/build_history'
        });
    }
}

class FirmwareBuildHistoryList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: FirmwareBuildHistory,
            endpoint: '/api/firmware/build_history',
            ...options
        });
    }
}

export { FirmwareBuild, FirmwareBuildList, FirmwareBuildHistory, FirmwareBuildHistoryList };
